import { RejectedInfo } from './../../../Services/Object_Classes/Weighting/Weighting';
import { Weighting, WeightPartList, BoxInfo } from '../../../Services/Object_Classes/Weighting/Weighting';
import { Component, Inject, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-parts-info',
  templateUrl: './parts-info.component.html',
  styleUrls: ['./parts-info.component.css']
})
export class PartsInfoComponent implements OnInit {
  title:string;
  record: Weighting;
  partInfo : WeightPartList;
  boxInfo: BoxInfo;
  rejectInfo: RejectedInfo[] = [];

  constructor(
      private dialogRef: MatDialogRef<PartsInfoComponent>,
      @Inject(MAT_DIALOG_DATA) data,
      private toast: ToastrService,
      private db: AngularFireDatabase,
      private dialog: MatDialog,
      private firestore: AngularFirestore,
      private angularFireAuth: AngularFireAuth,
      private spinner: NgxSpinnerService
    ) {
      this.title = data.PO_No
      this.record = data;
    }

  ngOnInit() {
  }
  cancel() {
    this.dialogRef.close(false);
  }
  view(part,box, reject){
    this.partInfo = part;
    this.boxInfo = box;
    this.rejectInfo = reject.slice();
  }

}
